import { render, staticRenderFns } from "./ModelPropertyValue.vue?vue&type=template&id=6284766e&"
import script from "./ModelPropertyValue.vue?vue&type=script&lang=ts&"
export * from "./ModelPropertyValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports